import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getWorkEnvironmentSurveyByUUID } from '../../api/workEnvironmentQueries';

export const WorkEnvironmentSurveyByUUIDQueryKey = 'WORK_ENVIRONMENT_SURVEY_BY_UUID';

/** The questions keep showing in the old language while the new one loads */
export const useGetWorkEnvironmentSurveyByUUIDQuery = (uuid: string | undefined, language: string) =>
  useQuery({
    queryKey: [WorkEnvironmentSurveyByUUIDQueryKey, uuid, language],
    queryFn: () => getWorkEnvironmentSurveyByUUID(uuid!, language),
    enabled: Boolean(uuid),
    placeholderData: keepPreviousData,
  });
